import { ContainerModule } from 'inversify';
import { SocketProcessingAdapter } from '@dealroadshow/file-uploader';
import { type ISocketClient } from '@drs/socket-client';
import SocketDITypes from '@drs/socket-client/DITypes';
import DITypes from './types';
import type {
  ISocketProcessingAdapter,
  IUploadDispatcherFactory,
  IUploadAdapter,
  IUploadDispatcher,
} from './interfaces';
import UploadAdapter from '../UploadAdapter';
import UploadDispatcherFactory from '../UploadDispatcherFactory';

export const FileUploadModule = new ContainerModule(({ bind }) => {
  bind<ISocketProcessingAdapter>(DITypes.SocketProcessingAdapter)
    .toDynamicValue(({ get }) => {
      const socketClient = get<ISocketClient>(SocketDITypes.SocketClient);
      return new SocketProcessingAdapter(socketClient);
    })
    .inSingletonScope();

  bind<IUploadAdapter>(DITypes.UploadAdapter).to(UploadAdapter).inSingletonScope();

  bind<IUploadDispatcherFactory>(DITypes.UploadDispatcherFactory).to(UploadDispatcherFactory).inSingletonScope();

  bind<IUploadDispatcher>(DITypes.UploadDispatcher)
    .toDynamicValue(({ get }) => {
      return get<IUploadDispatcherFactory>(DITypes.UploadDispatcherFactory).create();
    })
    .inSingletonScope();
});
